import React from 'react';

import { useClassnames } from '@lumapps/classnames';
import { SkeletonTypography, Typography } from '@lumapps/lumx/react';

import { VideoPublisher, VideoPublisherProps } from '../../VideoPublisher';
import { useBlockVideoContext } from '../BlockVideoContext';
import { CLASSNAME as BLOCK_VIDEO_CLASSNAME } from '../constants';

export const CLASSNAME = `${BLOCK_VIDEO_CLASSNAME}-author` as const;

type AuthorProps = Omit<VideoPublisherProps, 'user' | 'id' | 'theme'>;

/**
 * Displays the author of a video
 */
export const Author = (videoPublisherProps: AuthorProps) => {
    const { block } = useClassnames(CLASSNAME);

    const { canDisplay, isLoading, theme, video } = useBlockVideoContext();

    if (!canDisplay('AUTHOR')) {
        return null;
    }

    if (isLoading) {
        return (
            <SkeletonTypography
                className={block({ skeleton: true })}
                theme={theme}
                typography={Typography.body1}
                width="20%"
            />
        );
    }

    if (!video?.createdByDetails) {
        return null;
    }

    return (
        <VideoPublisher
            {...videoPublisherProps}
            className={block()}
            id={video.createdById}
            theme={theme}
            user={video.createdByDetails}
        />
    );
};
